import React from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as TriangleFlag } from "../../../../assets/icons/TriangleFlag.svg";
import { ReactComponent as EmptyAssessments } from "../../../../assets/images/EmptyAssessments.svg";
import { flagLabels } from "../../../../constants/constants";
import moment from "moment";
import PatientLoader from "../../../common/PatientLoader";

export const FlagLabels = ({ label }) => {
  if (label?.toLowerCase() === "positive_mood") {
    return null;
  }

  return (
    <div className="flag-label" style={flagLabels[label?.toLowerCase()]}>
      {label?.replaceAll("_", " ")}
    </div>
  );
};

export const JournalEntry = ({
  date,
  text,
  labels = [],
  entry = {},
  isSelected = false,
  isClickable = false,
  lablesPosition = "top",
  setSelectedJournal = () => {},
}) => {
  return (
    <div
      className={`journal-entry-container${isSelected ? "-selected" : ""} my-3`}
      style={{ cursor: isClickable ? "pointer" : "auto" }}
      onClick={() => {
        setSelectedJournal(entry);
      }}
    >
      <div className="d-flex justify-content-between mb-3">
        <label className="primary-text-blue" style={{ fontSize: "1.3rem" }}>
          {moment(date).format("MMM DD, YYYY")}
        </label>
        {lablesPosition === "top" && (
          <div className="d-flex" style={{ gap: "4px" }}>
            {labels?.length > 0 &&
              labels.map((item, index) => {
                return <FlagLabels key={index} label={item} />;
              })}
          </div>
        )}
      </div>
      <article>{text}</article>
      {lablesPosition === "bottom" && (
        <div className="d-flex" style={{ gap: "4px" }}>
          {labels?.length > 0 &&
            labels.map((item, index) => {
              return <FlagLabels key={index} label={item} />;
            })}
        </div>
      )}
    </div>
  );
};
export const NoAssessments = ({
  text = "There are no flagged assessments.",
  link = "/patients/assessments/1234",
  link_text = "Go to Assessments",
  has_link = false,
  show_link = true,
  callback = () => {},
}) => {
  return (
    <div className="container-fluid text-center my-5">
      <EmptyAssessments width={200} height={200} />
      <div className="container-fluid text-center">
        <span style={{ display: "block", fontWeight: "bold" }}>{text}</span>
        {show_link && (
          <>
            {has_link ? (
              <Link
                to={link}
                style={{
                  color: "#395e9d",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                {link_text}
              </Link>
            ) : (
              <small
                style={{
                  color: "#395e9d",
                  textDecoration: "underline",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  callback();
                }}
              >
                {link_text}
              </small>
            )}
          </>
        )}
      </div>
    </div>
  );
};
const FlaggedJournals = (props) => {
  const { assessmentsLoading, assessmentsData } = useSelector(
    (state) => state.assessment
  );

  return (
    <CardLayout
      className={`col-sm-12 col-md-${props?.size} col-lg-${props?.size}`}
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        <div className="d-flex justify-content-between mb-4 mt-2">
          <label style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}>
            {/* <TriangleFlag /> Flagged Journals */}
            Recent Journals
          </label>

          <small
            onClick={() => {
              props.setJournalsTab();
            }}
            style={{
              color: "#395e9d",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            View all {">"}
          </small>
        </div>
        {assessmentsLoading ? (
          <div className="container-fluid">
            <PatientLoader />
          </div>
        ) : (
          <>
            {assessmentsData &&
              assessmentsData?.journal?.length > 0 &&
              assessmentsData?.journal
                .slice(0, 3)
                .filter((item) => {
                  if (
                    item?.nlp_results?.length > 0 ||
                    !item?.entry?.includes("created on basis of ")
                  ) {
                    return item;
                  }
                })
                .map((entry, index) => {
                  return (
                    <JournalEntry
                      key={index}
                      date={entry?.modified}
                      text={entry?.entry}
                      labels={
                        entry?.nlp_results?.length > 0
                          ? entry?.nlp_results.map((item) => {
                              return item?.predicted_label || "";
                            })
                          : []
                      }
                      entry={entry}
                      setSelectedJournal={(entry) => {
                        console.log(entry);
                      }}
                    />
                  );
                })}

            {assessmentsData && assessmentsData?.journal?.length < 1 && (
              <NoAssessments
                text={"There are no flagged journals"}
                link_text="Go to Journals"
                callback={() => {
                  props.setJournalsTab();
                }}
              />
            )}
          </>
        )}
      </div>
    </CardLayout>
  );
};

export default FlaggedJournals;
